import { render, staticRenderFns } from "./maintitle.vue?vue&type=template&id=4f9fa1a0&scoped=true"
import script from "./maintitle.vue?vue&type=script&lang=js"
export * from "./maintitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9fa1a0",
  null
  
)

export default component.exports